/* eslint
    no-empty-function: "warn",
    default-case: "warn",
    no-underscore-dangle: "off"
*/

import {element, globalEvent} from '@shared/easyfy.core';
import {invoke} from '@shared/easyfy.decorators';
import {addCss, removeCss} from '@shared/easyfy.utils';

namespace Meds.Modules {
  @invoke
  class CustomerChat {
    private static isWidgetOpen: boolean = false;

    private static isListenerAdded: boolean = false;

    onInit() {
      globalEvent({
        type: 'click',
        event: {
          action: 'customerchat-toggler-click',
          callback: CustomerChat.ToggleCustomerChatWidget
        }
      });
    };

    static ToggleCustomerChatWidget = async () => {
      CustomerChat.ToggleDixaWidget();
    };

    static ToggleDixaWidget() {
      const dixa = (window as { _dixa_?: any })._dixa_;
      if (dixa) {

        if (CustomerChat.isListenerAdded === false) {
          // Add event listener from dixa when widget change open state
          dixa.addListener("on-widget-open-changed", (isOpen: boolean) => {
            CustomerChat.OnDixaWidgetOpenChanged(isOpen);
          });
          CustomerChat.isListenerAdded = true;
        }

        dixa.invoke("setWidgetOpen", !CustomerChat.isWidgetOpen);
      }
    }

    static OnDixaWidgetOpenChanged(isOpen: boolean) {
      CustomerChat.isWidgetOpen = isOpen;

      const widgetOpenElement: HTMLElement = element(
        '.support-chat-toggler-open'
      );
      const widgetCloseElement: HTMLElement = element(
        '.support-chat-toggler-close'
      );

      addCss(isOpen ? widgetOpenElement : widgetCloseElement, 'hidden');
      removeCss(isOpen ? widgetCloseElement : widgetOpenElement, 'hidden');
    }
  }
}
